import dayjs from "dayjs";
import React from "react";
import { NavLink } from "react-router-dom";
import "./styles.scss";

import { useMe } from "../../../hooks/queries";
import { MediaData } from "../../../models/MediaData";

export interface IMediaItemProps {
  mediaItem: MediaData | null;
  hideLocationName?: boolean;
}

export const MediaItem: React.FunctionComponent<IMediaItemProps> = (props) => {
  const { mediaItem, hideLocationName } = props;
  const { data: me } = useMe();

  if (!mediaItem) return null;

  const logoUrl = "/assets/logo.png";

  const locationPath = me?.organization_id
    ? `/location/${mediaItem.location_id}/organization/${me?.organization_id}`
    : `/location/${mediaItem.location_id}`;

  return (
    <div className="media-item" key={mediaItem.id}>
      <div className="media-top-info">
        <div className="left-title">
          {!hideLocationName && (
            <NavLink to={locationPath}>{mediaItem.location_name}</NavLink>
          )}
        </div>
        <div className="right-title">
          {dayjs(mediaItem.post_date).format("YYYY-MM-DD")}
        </div>
      </div>
      <a
        className="media-img-container"
        href={mediaItem.url || logoUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="media-img"
          alt="media"
          src={mediaItem.url || logoUrl}
          referrerPolicy="no-referrer"
        />
      </a>
    </div>
  );
};

export default MediaItem;
